import axios, { AxiosResponse, AxiosError } from 'axios';
import { Modal } from 'antd';
import AppConsts from '../libs/AppConsts';
import i18n from '../utils/Locale/i18n';

const http = axios.create({
  baseURL: AppConsts.host,
  headers: { 'Content-Type': 'application/json' },
});

http.defaults.headers['accept-language'] = i18n.language;

// Request interceptor to add the token to every request
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token360');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const selectedLanguage = i18n.language;
    config.headers['accept-language'] = selectedLanguage;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 Unauthorized globally
http.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    if (!error.config) {
      return;
    }

    if (error.response?.status === 400) {
      const data = error.response.data as any;

      let text = data?.message;

      Modal.error({
        title: 'Внимание',
        content: text,
        okText: 'Понятно',
      });
    }
    if (error.response?.status === 401) {
      localStorage.removeItem('token360');
      window.location.reload();
    }

    return Promise.reject(error);
  }
);

export default http;
